import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { ExtensionComponentProps } from "@/extensions/registry";
import { EscaladeDentalBookingManager } from "@/extensions/escalade-dental/bookings/booking-manager";
import { EscaladeDentalUnavailableSchedules } from "@/extensions/escalade-dental/bookings/unavailable-schedules";

export function EscaladeDentalBookingsExtension({ tenantSlug, extension }: ExtensionComponentProps) {
  return (
    <Tabs defaultValue="bookings" className="space-y-4">
      <TabsList>
        <TabsTrigger value="bookings">Bookings</TabsTrigger>
        <TabsTrigger value="unavailable-schedules">Unavailable Schedules</TabsTrigger>
      </TabsList>

      <TabsContent value="bookings">
        <EscaladeDentalBookingManager tenantSlug={tenantSlug} extension={extension} />
      </TabsContent>

      <TabsContent value="unavailable-schedules">
        <EscaladeDentalUnavailableSchedules tenantSlug={tenantSlug} extension={extension} />
      </TabsContent>
    </Tabs>
  );
}
